import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetHealthCheckQuery } from "@/services/ExternalAPIServices";
import { selectCurrentToken } from "@/store/authSlice";
import {
  selectHealthChecks,
  updateHealthChecks,
} from "@/store/healthCheckSlice";

export const useHealthCheckPolling = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectCurrentToken);
  const currentHealthChecks = useSelector(selectHealthChecks);
  const { data: newHealthChecks, refetch } = useGetHealthCheckQuery(undefined, {
    skip: !token,
  });
  const prevHealthChecksRef = useRef(newHealthChecks);

  useEffect(() => {
    if (!token) return;

    const healthChecks = Array.isArray(newHealthChecks) ? newHealthChecks : [];

    // Update health checks immediately when data is available
    if (healthChecks !== prevHealthChecksRef.current) {
      const updatedChecks = healthChecks.map((newCheck) => {
        const existingCheck = currentHealthChecks.find(
          (check) => check.type_id === newCheck.type_id
        );
        const inactive_duration = existingCheck
          ? newCheck.is_healthy
            ? 0
            : existingCheck.inactive_duration + 2
          : newCheck.is_healthy
            ? 0
            : 2;
        return { ...newCheck, inactive_duration };
      });
      dispatch(updateHealthChecks(updatedChecks));
      prevHealthChecksRef.current = healthChecks;
    }

    // Set up interval for periodic updates
    const interval = setInterval(
      () => {
        refetch();
      },
      2 * 60 * 1000
    );

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, newHealthChecks, dispatch, refetch]); // Removed currenHealthChecks from deps
};
